import React from "react";
import { StyledATag, styles } from "../styles";
import Box from "@mui/material/Box";
import PropTypes from 'prop-types';

const Sidebar = ({isActiveSidebar,handleSidebar}) => {
    
    const handleATagClick = (e) => {
        e.preventDefault();
    }
    return(
        <div>
            <Box style={styles.sidebar}>
            <ul style={styles.sidebarList}> 
                {['Overview','Getting Started','Authorization','Patient Access','Provider Directory','Privacy And Terms of Service','Contact Us'].map(id=> (
                    <button key={id} style= {styles.sidebarItem(isActiveSidebar===id)} onClick={()=>handleSidebar(id)}>
                       <StyledATag href={id} style= {{textDecoration:'none'}} onClick={handleATagClick}>{id}</StyledATag> 
                    </button>
                ))}
            </ul>
            </Box>
        </div>
    )
}

Sidebar.propTypes = {
    isActiveSidebar: PropTypes.string.isRequired,
    handleSidebar: PropTypes.func.isRequired,
}

export default Sidebar;